import { useState, useEffect } from "react";

const INCREMENT_QUEUE_ON_PRINT = "incrementQueueOnPrint";

// eslint-disable-next-line import/prefer-default-export
export const useIncrementQueueOnPrint = (): {
  incrementQueueOnPrint: boolean;
  toggleIncrementQueueOnPrint: () => void;
} => {
  const [incrementQueueOnPrint, setIncrementQueueOnPrint] = useState<boolean>(() => {
    const value = localStorage.getItem(INCREMENT_QUEUE_ON_PRINT);
    return value ? JSON.parse(value) : true;
  });

  useEffect(() => {
    localStorage.setItem(INCREMENT_QUEUE_ON_PRINT, JSON.stringify(incrementQueueOnPrint));
  }, [incrementQueueOnPrint]);

  const toggleIncrementQueueOnPrint = () => {
    setIncrementQueueOnPrint((prev) => !prev);
  };

  return { incrementQueueOnPrint, toggleIncrementQueueOnPrint };
};
